<template>
    <div class="mx-auto container">
        <SectionWrapper borderPosition="between" type="full">
            <template #title>
                {{ $t('Finance Chart') }}
            </template>
            <template #content>
                <Tabs v-model:data="tabs" activeColor="#000000" v-model:activeTab="activeTab" :overlay="false" align="start" :firstOnLoad="true" class="py-16">
                    <template #header="{ data }">
                        <strong>
                            {{ $translate(data.title) }}
                        </strong>
                    </template>

                    <template #item="{ data }">
                        <Chart :options="data.chart" />
                    </template>
                </Tabs>
            </template>
        </SectionWrapper>

        <SectionWrapper borderPosition="between" type="full">
            <template #title>
                {{ $t('Crypto Chart') }}
            </template>
            <template #content>
                <CryptoMarket :options="crypto" />
            </template>
        </SectionWrapper>
    </div>
</template>

<script>
import { Chart, CryptoMarket } from 'vue-tradingview-widgets';

export default {
    data: () => ({
        tabs: [
            {
                title: 'EUREX:FDAX1!',
                chart: {
                    symbol: 'EUREX:FDAX1!',
                    showSymbolLogo: true,
                    colorTheme: 'light',
                    locale: 'de'
                }
            },
            {
                title: 'EUREX:FDAX1!',
                chart: {
                    symbol: 'EUREX:FDAX1!',
                    showSymbolLogo: true,
                    colorTheme: 'light',
                    locale: 'de'
                }
            }
        ],
        crypto: {
            symbols: [
                {
                    proName: 'BITTREX:DOGEUSD',
                    title: 'Dogecoin'
                },
                {
                    proName: 'BITTREX:ADAUSD',
                    title: 'Chainlink'
                }
            ],
            showSymbolLogo: true,
            colorTheme: 'light',
            locale: 'de'
        },
        activeTab: 0
    }),
    components: {
        Chart,
        CryptoMarket
    }
};
</script>
